/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MonitorLicenses { 
    kpi_dairy?: boolean;
    kpi_brewery?: boolean;
    condition_monitoring?: boolean;
    optipartner?: boolean;
}

